import React, {FC} from "react"
import moment from "moment"

import {H5, H6, Label, Body} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import mainTheme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"
import {CompanyValue, CelebrationsReportPoll} from "@irati/types"
import {Tooltip, OverlayPlacement} from "@irati/ui/src/Tooltip"

import PictureGroup from "../../PictureGroup"
import ViewLink from "../../ViewLink"
import {FlexStartH6} from "../styled"
import {StyledCard} from "./styled"

interface Props {
  index: number
  poll?: CelebrationsReportPoll
}

const PollCard: FC<Props> = ({poll, index}) => {
  const {title, criteria, totalVotes, totalNominees, companyValues, pollId} = poll

  const startOfPoll = moment.unix(poll?.createdAt?.seconds)
  const endOfPoll = moment.unix(poll?.voteEndedAt?.seconds)
  const pollLengthInDays = Math.ceil(moment.duration(endOfPoll.diff(startOfPoll)).asDays())

  return (
    <StyledCard marginTop={2} marginBottom={2} bgColor={mainTheme.colors.greys.lightest} padding={2}>
      <Flex direction="column" justifyContent="space-between" height="100%">
        <Flex marginBottom={1} alignItems="flex-start">
          <FlexStartH6 color={mainTheme.colors.primary1} marginRight={1}>
            {index + 1}
          </FlexStartH6>
          <Flex marginLeft={1} direction="column" minHeight="72px">
            <H6>{title}</H6>
            <Label small>{criteria}</Label>
          </Flex>
        </Flex>
        <div>
          <Flex direction="column" height="80px">
            {!!companyValues?.results.length && (
              <>
                <Label small marginBottom>
                  <FormattedMessage id="admin.reporting.celebrations.pollCard.companyValues.title" />
                </Label>
                <Tooltip
                  tooltipChildren={companyValues.results.map((value: CompanyValue) => (
                    <Body small>{value.name}</Body>
                  ))}
                  placement={OverlayPlacement.Bottom}>
                  <Flex>
                    <PictureGroup values={companyValues.results.map((value) => ({...value, count: 1}))} />
                  </Flex>
                </Tooltip>
              </>
            )}
          </Flex>
          <Card padding={mainTheme.spacing.oneAndHalf}>
            <Label small marginBottom>
              <FormattedMessage id="admin.reporting.celebrations.pollCard.totalVotesReceived.title" />
            </Label>
            <H5>{totalVotes}</H5>
            <Label small marginBottom>
              <FormattedMessage id="admin.reporting.celebrations.pollCard.votingPeriod.title" />
            </Label>
            <H5>
              <FormattedMessage id="admin.reporting.celebrations.pollCard.votingPeriod.value" values={{days: pollLengthInDays}} />
            </H5>
            <Label small marginBottom>
              <FormattedMessage id="admin.reporting.celebrations.pollCard.totalNominees.title" />
            </Label>
            <H5>{totalNominees}</H5>
          </Card>
          <ViewLink text="admin.reporting.celebrations.pollCard.link" to={`/polls/poll/${pollId}`} />
        </div>
      </Flex>
    </StyledCard>
  )
}

export default PollCard
